// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getCategoriesListStatus: { data: null },
  createCategoriesStatus: { data: null },
  updateCategoriesStatusStatus: { data: null },
  getCategoriesStatus: { data: null },
  deleteCategoriesStatus: { data: null },
};
